import getApiClient from '@/plugins/api'

export default {

    loadCustomersTrips() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.idTrip = this.$route.params.idTrip
        self.search = {};

        self.$store.commit('startLoading')

        self.search.page = self.page
        self.search.itemsPerPage = self.perPage

        // FILTERS
        if (self.searchParams.customerName) {
            self.search['name'] = self.searchParams.customerName
        }

        if (self.searchParams.customerDocument) {
            self.search['document'] = self.searchParams.customerDocument.replace(/[^0-9]+/g, '')
        }

        if (self.searchParams.customerPhone) {
            self.search['phone'] = self.searchParams.customerPhone.replace(/[^0-9]+/g, '')
        }

        if (self.idTrip) {
            self.search['trip'] = self.idTrip
        }

        // GET
        api.get(`/customers/list`, {
            params: self.search
        })
            .then((result) => {
                self.customers = [];
                self.customers = result.data['hydra:member'];
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    changePage: function(page) {
        this.page = page
    },

}
